
import { readShowOverlayLoadingIndicator } from '@/store/main/getters';
import { Component, Vue, Watch } from 'vue-property-decorator';

@Component
export default class OverlayLoadingIndicator extends Vue {
    public show: boolean = false;
    public text: string = '';

    public get showOverlayLoadingIndicator() {
        return readShowOverlayLoadingIndicator(this.$store);
    }

    @Watch('showOverlayLoadingIndicator')
    public onShowOverlayLoadingIndicatorChange(
        newShowOverlayLoadingIndicator: boolean,
        oldShowOverlayLoadingIndicator: boolean,
    ) {
        this.show = newShowOverlayLoadingIndicator;
    }
}

